// generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/OutfitMultiplicationTask.js
// Zasada mnożenia — 3 elementy (koszulka + spodnie + buty)

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const shirts = Math.floor(Math.random() * 6) + 5;  // 5–10
  const pants  = Math.floor(Math.random() * 6) + 3;  // 3–8
  const shoes  = Math.floor(Math.random() * 4) + 2;  // 2–5

  return {
    type: "OutfitMultiplicationTask",
    data: { shirts, pants, shoes, answer: shirts * pants * shoes },
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { shirts, pants, shoes } = data;
  return (
    <div style={{ textAlign: "left" }}>
      <p>
        Uczeń wybiera strój: <strong>koszulka</strong>,{" "}
        <strong>spodnie</strong>, <strong>buty</strong>.
        <br />
        Do wyboru ma <InlineMath math={String(shirts)} /> koszulek,{" "}
        <InlineMath math={String(pants)} /> par spodni i{" "}
        <InlineMath math={String(shoes)} /> par butów.
        <br />
        Na ile sposobów może skompletować cały strój?
      </p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label=""   // ⬅️ wymusza brak prefiksu w podglądzie
      placeholder="Wpisz liczbę sposobów"
    />
  );
}

// ==== LOGIKA ODP ====

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") {
    return { correct: false, message: "Podaj liczbę." };
  }
  const given = parseInt(userAnswer.raw, 10);
  if (Number.isNaN(given)) {
    return { correct: false, message: "Podaj liczbę całkowitą." };
  }

  const correct = given === data.answer;
  userAnswer.correctAnswer = data.answer;

  return { correct, message: correct ? "Dobrze!" : "Spróbuj ponownie." };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`${data.answer}`} />;
}

export function renderUserAnswer(userAnswer, task) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`${userAnswer.raw}`} />;
}

// ==== WYJAŚNIENIE ====

export function renderExplanation({ data }) {
  const { shirts, pants, shoes, answer } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p><strong>Krok 1. Ustalamy liczby możliwości.</strong></p>
      <ul>
        <li>Koszulka: <InlineMath math={String(shirts)} /> możliwości.</li>
        <li>Spodnie: <InlineMath math={String(pants)} /> możliwości.</li>
        <li>Buty: <InlineMath math={String(shoes)} /> możliwości.</li>
      </ul>

      <p><strong>Krok 2. Zasada mnożenia — wykonujemy iloczyn.</strong></p>
      <BlockMath math={`${shirts} \\cdot ${pants} \\cdot ${shoes} = ${answer}`} />
    </div>
  );
}
